import React from 'react';
import { string, arrayOf, shape, func, oneOfType, object } from 'prop-types';

import OutlineTabs from '@dragonfruit/components/OutlineTabs';
import OutlineSelect from '@dragonfruit/components/fields/OutlineSelect';

import styles from './TabSelect.scss';

function TabSelect({ options, value, onChange }) {
  const transformedTabs = options.map(({ value, label }) => ({
    key: value,
    title: label,
  }));

  const handleChangeTab = selected => onChange(selected.key);

  const handleChangeSelect = selected => onChange(selected.value);

  return (
    <div data-show-select={options.length <= 3}>
      <OutlineTabs
        tabs={transformedTabs}
        onTabSelect={handleChangeTab}
        activeTabKey={value}
        className={styles.tabs}
      />

      <OutlineSelect
        className={styles.select}
        value={value}
        options={options}
        onChange={handleChangeSelect}
        openOnClick
        searchable={false}
        clearable={false}
      />
    </div>
  );
}

TabSelect.propTypes = {
  onChange: func.isRequired,
  options: arrayOf(
    shape({
      value: string.isRequired,
      label: oneOfType([string, object]).isRequired,
    })
  ),
  value: string,
};

TabSelect.defaultProps = {
  value: null,
};

export default TabSelect;



// WEBPACK FOOTER //
// ./app/components/TabSelect/TabSelect.jsx